import React, { ReactNode } from "react";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import Button from "./Button";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";

interface Props {
  title?: string;
  bodyText?: string | ReactNode;
  visible: boolean;
  cancelText?: string;
  confirmText?: string;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  children?: ReactNode;
}

const ConfirmDialog = ({
  visible,
  title,
  bodyText,
  onCancel,
  onConfirm,
  children,
  ...rest
}: Props) => {
  const handleCancel = () => {
    if (typeof onCancel === "function") {
      onCancel();
    }
  };

  const handleConfirm = () => {
    if (typeof onConfirm === "function") {
      onConfirm();
    }
  };

  return (
    <Dialog
      open={visible}
      onClose={handleCancel}
      aria-labelledby="eh-confirm-dialog-title"
      aria-describedby="eh-confirm-dialog-description"
      className="eh-confirm-dialog"
      maxWidth={false}
      PaperProps={{ className: "eh-confirm-dialog__paper" }}
    >
      <DialogTitle disableTypography id="eh-confirm-dialog-title">
        <div className="eh-confirm-dialog__header">
          <h4>{title || "Heads up!!!"}</h4>
          <IconButton
            aria-label="close"
            className="eh-confirm-dialog__close"
            onClick={handleCancel}
          >
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <div id="eh-confirm-dialog-description" className="eh-confirm-dialog__body">
          {bodyText}
          {children}
        </div>
      </DialogContent>
      <DialogActions className="eh-confirm-dialog__actions">
        <Button variant="outlined" onClick={handleCancel}>
          {rest.cancelText || "Cancel"}
        </Button>
        <Button
          onClick={handleConfirm}
          loading={rest.loading}
          autoFocus
        >
          {rest.confirmText || "Confirm"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
